import React, { Dispatch, FC, SetStateAction } from 'react'
import { ActionIcon, ScrollArea, Table, Text, Tooltip } from "@mantine/core"
import { useAppState } from '../../../../hooks/redux'
import { IconCopy } from '@tabler/icons-react'
import { VectorSearchFilters } from '../../../../lib/types'

interface CopyMatchesProps {
  setUpdatedFilters: Dispatch<SetStateAction<VectorSearchFilters>>
  setCurrentTab: Dispatch<SetStateAction<string | null>>
}

export const CopyMatches: FC<CopyMatchesProps> = ({ setUpdatedFilters, setCurrentTab }) => {
  const appState = useAppState()
  const matchesGrid = appState.marketPricing.JobPricingReducer.JobPricingGridReducer
  const { terms, data } = matchesGrid

  const tableHeaders = [
    { columnHeader: 'Job Title', element: 'job_title_default', tooltip: 'job_description_default' },
    { columnHeader: 'Survey', element: 'survey_code_default', tooltip: 'pub_survey_short_name_default' },
    // { columnHeader: 'Data Cut', element: 'job_scope_default' },
  ]

  const dataWithTerms: any[] = []
  data.forEach((row) => {
    const combinedRow = row.map((element: any, i: number) => ({ ...terms[i], value: element }))
    dataWithTerms.push(combinedRow)
  })

  const rows = dataWithTerms.map(row => {
    const rowData: any[] = []
    tableHeaders.forEach(th => {
      const element = row.find((r: any) => r.term === th.element).value
      const tooltip = row.find((r: any) => r.term === th.tooltip).value ?? null
      rowData.push({ value: element, tooltip })
    })
    return rowData
  })

  const handleCopy = (rowIndex: number) => {
    const rowData = dataWithTerms[rowIndex]
    // const jobTitle: string = rowData.find((rd: any) => rd.term === 'job_title_default').value || ''
    const jobDescription: string = rowData.find((rd: any) => rd.term === 'job_description_default').value || ''
    // const surveyCode = rowData.find((rd: any) => rd.term === 'survey_code_default').value || ''
    // const surveyShortName = rowData.find((rd: any) => rd.term === 'pub_survey_short_name_default').value || ''
    // const dataCut = [rowData.find((rd: any) => rd.term === 'job_scope_default').value || '']
    // const surveyCodeSurveyShortName: string[] = [`${surveyShortName} - ${surveyCode}`]
    if (!jobDescription) return 
    const updatedFilters = { jobDescription }
    setUpdatedFilters(prev => ({ ...prev, ...updatedFilters }))
    setCurrentTab('filters')
  }

  const hasDescription = (rowIndex: number) => {
    const rowData = dataWithTerms[rowIndex]
    return !!rowData.find((rd: any) => rd.term === 'job_description_default').value
  }

  if (!data) return <Text mt={250}>This job has no matches.</Text>

  return (
    <ScrollArea h={800}>
      <Table stickyHeader>
        <Table.Thead>
            <Table.Tr>
            { tableHeaders.map(th => <Table.Th>{th.columnHeader}</Table.Th>)}
            </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ overflow: 'scroll' }}>
        { rows.map((row, rowIndex) => ( 
          <Table.Tr key={rowIndex}>
            { row.map(el => (
              <Table.Td>
                <Tooltip transitionProps={{ transition: 'fade-down', duration: 300 }} inline maw={800} withArrow position='bottom' multiline label={el.tooltip ?? 'This job has no job description'}>
                  <Text inherit span>{el.value}</Text>
                </Tooltip>
              </Table.Td>
            ))}
            <Table.Tr>
              <Tooltip transitionProps={{ transition: 'fade-down', duration: 300 }} inline maw={800} withArrow position='bottom' multiline disabled={hasDescription(rowIndex)} label='No job description to copy'>
                <ActionIcon mt={5} disabled={!hasDescription(rowIndex)} variant="transparent" onClick={() => handleCopy(rowIndex)}>
                  <IconCopy style={{ width: '70%', height: '70%' }} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            </Table.Tr>
          </Table.Tr>))}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  )
} 
